import { css } from "styled-components";

export const HeadlineLinkStyles = css`
  font-style: italic;
  cursor: pointer;
`;
